/**
 * フォーム回答率に応じて進捗バーを表示する
 * **/

import $ from 'jquery';

// フォーム項目名一覧
const formItemsMaster = [
    'preferred_date',
    'name',
    'kana',
    'email',
    'address',
    'telephone',
    'question',
    'scheduled_date',
    'participants',
    'original1',
    'original2',
    'original3',
];

/**
 * 必須項目名一覧を取得
 */
const getRequiredItems = () => {
    const formItems = $('.form__list').data('form_list'); // サイト別フォーム項目一覧
    let requiredItems = [];
    // 必須項目一覧のみに絞る
    if (formItems !== undefined) {
        requiredItems = formItemsMaster.filter(
            item => formItems.includes(item + '_required')
        );
    }

    // 日付の必須項目の整理
    requiredItems = addPreferredDateItems(formItems, requiredItems);

    // 住所が必須の場合は郵便番号を必須項目に追加
    if (requiredItems.indexOf('address') >= 0) {
        requiredItems.push('zip');
    }

    // プラポリチェック追加
    requiredItems.push('privacy');

    return requiredItems;
};

/**
 * 日付の必須項目名を追加
 *
 * @param formItems
 * @param requiredItems
 */
const addPreferredDateItems = (formItems, requiredItems) => {
    // 希望日が必須の場合は第一と第二を分けて必須項目に追加
    if (requiredItems.indexOf('preferred_date') >= 0) {
        requiredItems.splice(requiredItems.indexOf('preferred_date'), 1); // preferred_date削除
        requiredItems.push('preferred_date1'); // 第一希望日追加

        if (formItems.includes('preferred_date_visible2') && formItems.includes('preferred_date_required2')) {
            // 第二希望日が表示の場合は必須項目に追加
            requiredItems.push('preferred_date2'); // 第二希望日追加
        }
    }
    
    return requiredItems;
};

const requiredItems = getRequiredItems(); // 必須項目名一覧
const requiredItemNum = requiredItems.length; // 必須項目数
let answeredItems = {}; // 回答済み必須項目

/**
 * 進捗バーの初期表示
 */
const initProgress = () => {
    // 必須項目の入力値チェック
    for (let value of requiredItems) {
        answeredItems = checkFormItems(value, answeredItems);
    }

    // 進捗バー表示
    confirmProgress(answeredItems, requiredItemNum);
};

/**
 * アイテムごとに入力値チェックをして結果を返却
 *
 * @param formType チェック対象項目
 * @param answeredItems 項目名とチェック結果のセット {formType: bool, formType: bool, ...}
 */
const checkFormItems = (formType, answeredItems) => {
    switch (formType) {
        case 'preferred_date1':
            answeredItems[formType] = checkPreferredDate('1');
            break;
        case 'preferred_date2':
            answeredItems[formType] = checkPreferredDate('2');
            break;
        case 'name':
            answeredItems[formType] = checkTextItem(formType);
            break;
        case 'kana':
            answeredItems[formType] = checkTextItem(formType);
            break;
        case 'email':
            answeredItems[formType] = checkTextItem(formType);
            break;
        case 'zip':
            answeredItems[formType] = checkTextItem(formType);
            break;
        case 'address':
            answeredItems[formType] = checkTextItem(formType);
            break;
        case 'telephone':
            answeredItems[formType] = checkTextItem(formType);
            break;
        case 'question':
            answeredItems[formType] = checkTextItem(formType);
            break;
        case 'scheduled_date':
            answeredItems[formType] = checkMarriageSchedule();
            break;
        case 'participants':
            answeredItems[formType] = checkTextItem(formType);
            break;
        case 'original1':
            answeredItems[formType] = checkTextItem(formType);
            break;
        case 'original2':
            answeredItems[formType] = checkTextItem(formType);
            break;
        case 'original3':
            answeredItems[formType] = checkTextItem(formType);
            break;
        case 'privacy':
            answeredItems[formType] = checkPrivacyCheck();
            break;
        default:
            break;
    }

    return answeredItems;
};

/**
 * 第一希望日の入力値チェック
 * 日付・時間・分（フェアの場合は分なし）が入力されているか
 *
 * @param number
 */
const checkPreferredDate = number => {
    const date = $('#preferred_date' + number).val();
    const hour = $('#reserve_hour' + number).val();
    const minute = $('#reserve_minute' + number).val();
    const time = $('#reserve_time' + number).val(); // フェア時間

    let resultTime = false;
    if (time !== undefined) {
        // フェア時間が選択されている場合はtrue
        resultTime = time.length > 0;
    } else if (hour !== undefined && minute !== undefined) {
        // 時間と分がどちらも選択されている場合はtrue
        resultTime = hour.length > 0 && minute.length > 0;
    }

    return date.length > 0 && resultTime;
};

/**
 * テキスト項目の入力値チェック
 * 1文字以上入力されているか
 *
 * @param formType 対象項目
 */
const checkTextItem = formType => {
    let text = $(`.js-form_check[name=${formType}]`).val();

    return text.length > 0;
};

/**
 * ご婚礼予定月の入力値チェック
 * 年月どちらも入力されているか
 */
const checkMarriageSchedule = () => {
    const year = $('.form__select[name="marriage_year"]').val();
    const month = $('.form__select[name="marriage_month"]').val();

    // 年で未定を選択した場合に月の選択は不要
    if(isNaN(year)){
        return year.length > 0;
    }

    return year.length > 0 && month.length > 0;
};

/**
 * プライバシーポリシー同意チェックボックスのチェック
 *
 * @returns {*}
 */
const checkPrivacyCheck = () => {
    const $privacyCheck = $('#privacy_check');

    // プライバシーポリシー同意チェック要素がない場合
    if ($privacyCheck.length <= 0) {
        return true; // チェック判定しない
    }

    return $privacyCheck.is(':checked');
}
/**
 * フォーム回答進捗表示
 *
 * @param answeredItems 回答郡 {formType: bool, formType: bool, ...}
 */
const confirmProgress = answeredItems => {
    // 必須項目がない場合は何もしない
    if (requiredItemNum == 0) {
        return false;
    }
    let answeredItemNum = 0; // 回答済み項目数
    if (Object.keys(answeredItems).length > 0) {
        // 項目別の回答結果を確認
        for (let key of Object.keys(answeredItems)) {
            if (answeredItems[key]) {
                // 回答結果がtrueの場合は回答済みに1足す
                answeredItemNum = answeredItemNum + 1;
            }
        }
    }

    let percentage = (answeredItemNum / requiredItemNum) * 100;
    $('.js-form-progress__answered').text(answeredItemNum);
    $('.js-form-progress__required').text(requiredItemNum);
    $('.js-form-progress__bar--now').css('width', percentage + '%');

    // 回答率が100%になった場合
    if (percentage == 100) {
        // 確認画面へのボタンを有効にします
        $('.js-form-progress__button').removeClass('is-disabled');
        setTimeout(() => {
            $('.js-form-progress__check').show(); // 最後にチェックマーク表示
        }, 950);
    } else {
        $('.js-form-progress__button').addClass('is-disabled');
        $('.js-form-progress__check').hide();
    }
};

$(() => {
    // 初期表示
    initProgress();

    // 固定フッターの確認画面への遷移ボタン（未回答の必須項目がある場合は押せないように）
    $('.js-form-progress__button').on('click', e => {
        if ($(e.currentTarget).hasClass('is-disabled')) {
            return false;
        }
    });

    // フォーム内容変更（1文字ずつ変更を検知）
    $('.js-form_check').on('keyup.form_check', e => {
        // 変更があった項目の取得
        const formType = $(e.currentTarget).data('form_key');
        if (requiredItems.indexOf(formType) >= 0) {
            // 変更があった項目が必須項目の場合はチェックに回す
            answeredItems = checkFormItems(formType, answeredItems);
            // 進捗率の更新
            confirmProgress(answeredItems);
        }
    });

    // フォーム内容更新
    $('form .js-form_check').on('change.form_check', e => {
        // 変更があった項目の取得
        const formType = $(e.currentTarget).data('form_key');
        if (requiredItems.indexOf(formType) >= 0) {
            // 変更があった項目が必須項目の場合はチェックに回す
            answeredItems = checkFormItems(formType, answeredItems);
            // 進捗率の更新
            confirmProgress(answeredItems);
        }
    });

    // 第一希望日のリセットボタンクリック時の挙動
    $('.js-date_cancel1').on('click', e => {
        setTimeout(function (){
            const formType = 'preferred_date1';
            if (requiredItems.indexOf(formType) >= 0) {
                // 変更があった項目が必須項目の場合はチェックに回す
                answeredItems = checkFormItems(formType, answeredItems);
                // 進捗率の更新
                confirmProgress(answeredItems);
            }
        }, 0);
    });

    // 第二希望日のリセットボタンクリック時の挙動
    $('.js-date_cancel2').on('click', e => {
        setTimeout(function (){
            const formType = 'preferred_date2';
            if (requiredItems.indexOf(formType) >= 0) {
                // 変更があった項目が必須項目の場合はチェックに回す
                answeredItems = checkFormItems(formType, answeredItems);
                // 進捗率の更新
                confirmProgress(answeredItems);
            }
        }, 0);
    });

    // プライバシーポリシーチェックの変更
    $('#privacy_check').on('change', () => {
        if (requiredItems.indexOf('privacy') >= 0) {
            // 変更があった項目が必須項目の場合はチェックに回す
            answeredItems = checkFormItems('privacy', answeredItems);
            // 進捗率の更新
            confirmProgress(answeredItems);
        }
    })
});
